import type { PoolFilters } from "../store/poolsStore";
import { SUPPORTED_POOL_NETWORKS } from "../supported-networks";

const ALLOWED_BY_LOWER = new Map(
	SUPPORTED_POOL_NETWORKS.map((name) => [name.toLowerCase(), name] as const),
);

export const EMPTY_NETWORK_FILTER: string[] = [];

/** Canonical CSV key for memo deps / setFilters diffs. */
export function networkFilterKey(networks: readonly string[]): string {
	return networks.join(",");
}

/**
 * Dedupe, drop unknown names/slugs, map to catalog display names, sort into
 * catalog order. Empty or a complete set both collapse to `[]` ("All Networks").
 */
export function normalizeNetworkFilter(values: readonly string[]): string[] {
	const seen = new Set<string>();
	for (const value of values) {
		const canonical = ALLOWED_BY_LOWER.get(value.trim().toLowerCase());
		if (canonical) seen.add(canonical);
	}
	if (seen.size === 0 || seen.size === SUPPORTED_POOL_NETWORKS.length) {
		return EMPTY_NETWORK_FILTER;
	}
	return SUPPORTED_POOL_NETWORKS.filter((name) => seen.has(name));
}

export function hasActivePoolFilters(filters: PoolFilters): boolean {
	if (filters.keyword.trim()) return true;
	if (filters.network.length > 0) return true;
	for (const key of ["protocol", "feeTier", "tvl", "1dVolume", "volTvl", "marketCap"] as const) {
		if (filters[key] !== "all") return true;
	}
	return false;
}

export function countActivePoolFilters(filters: PoolFilters, hasPair: boolean): number {
	let count = hasPair ? 1 : 0;
	if (filters.keyword.trim()) count++;
	if (filters.network.length > 0) count++;
	for (const key of ["protocol", "feeTier", "tvl", "1dVolume", "volTvl", "marketCap"] as const) {
		if (filters[key] !== "all") count++;
	}
	return count;
}
